<script setup lang="ts">
type AnnouncementVariant = 'home' | 'register' | 'games';

type Props = {
  variant?: AnnouncementVariant;
};

const { variant = 'home' } = defineProps<Props>();

type Emits = {
  close: [];
};

const emit = defineEmits<Emits>();

// Cada variante aponta para um bloco de textos em utils/texts.json.
const TEXT_BASE: Record<AnnouncementVariant, string> = {
  home: 'home.announcement',
  register: 'home.register_announcement',
  games: 'home.games_announcement',
};

const texts = computed(() => {
  const base = TEXT_BASE[variant];

  return {
    title: `${base}.title`,
    paragraph1: `${base}.paragraph_1`,
    paragraph2: `${base}.paragraph_2`,
    paragraph3: `${base}.paragraph_3`,
  };
});
</script>

<template>
  <div
    :class="$style.overlay"
    @click.self="emit('close')"
  >
    <div :class="$style.card">
      <BaseModalCloseButton @close="emit('close')" />

      <!--
        BANNER: quando a arte estiver pronta, colocar aqui (topo do card).
        Ex.: <BaseCommonCustomNuxtImg :src="..." :class="$style.banner" />
      -->

      <BaseCommonLogo
        always-logo
        class="m-0 p-0 h-8 min-w-12 w-auto"
        custom-size
      />

      <h2 :class="$style.title">
        {{ $t(texts.title) }}
      </h2>

      <div :class="$style.text">
        <p>{{ $t(texts.paragraph1) }}</p>
        <p>{{ $t(texts.paragraph2) }}</p>
        <p>{{ $t(texts.paragraph3) }}</p>
      </div>
    </div>
  </div>
</template>

<style module lang="postcss">
.overlay {
  @apply fixed inset-0 z-10 flex items-center justify-center p-4;
}

.card {
  @apply relative w-full max-w-lg bg-bg-primary text-texts rounded-2xl p-8 pt-12 flex flex-col items-center gap-6 text-center select-none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);
}

.title {
  @apply text-2xl font-bold text-primary;
}

.text {
  @apply flex flex-col gap-4;

  p {
    @apply text-base font-medium text-texts/90 leading-relaxed;
  }
}
</style>
